<template>
  <LoadingPadrao
    v-if="tipoLoading == 1"
    tipo="circulo"
    :conteudo="fraseLoading"
    :escala="escala ? escala : '0.5'"
    :tamanho="tamanho ? tamanho : '50'"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <LoadingPadrao
    v-else-if="tipoLoading == 2"
    tipo="bloco"
    :conteudo="fraseLoading"
    :tamanho="tamanho ? tamanho : '36'"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <LoadingPadrao
    v-else-if="tipoLoading == 3"
    tipo="simples"
    :conteudo="fraseLoading"
    :tamanho="tamanho ? tamanho : '36'"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <LoadingPadrao
    v-else-if="tipoLoading == 4"
    tipo="quadrado"
    :conteudo="fraseLoading"
    :tamanho="tamanho ? tamanho : '20'"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <LoadingPadrao
    v-else-if="tipoLoading == 5"
    tipo="linha"
    :conteudo="fraseLoading"
    :tamanho="tamanho ? tamanho : '36'"
    numero="8"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <div
    :style="tamanho ? `font-size: ${tamanho}px;` : ''"
    v-else-if="!tipoLoading || tipoLoading == '' || tipoLoading == 0"
    class="loading-velho-mini"
  >
    <font-awesome-icon icon="spinner" spin />
  </div>
</template>

<script>
import LoadingPadrao from "@/components/LoadingPadrao/LoadingPadrao.vue";

export default {
  name: "LoadingPadraoContainer",
  components: {
    LoadingPadrao
  },
  props: {
    background: Boolean,
    fraseLoading: Array,
    tamanho: String,
    escala: String,
    classe: String,
    delay: String,
    tipo: String
  },
  computed: {
    tipoLoading() {
      if (this.tipo) {
        return this.tipo;
      }
      return "4";
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-velho-mini {
  font-size: 15px;
  display: flex;
  justify-content: center;
}
</style>
